import {
  createQueryClientProvider,
  type CreateQueryClientProviderComponent,
  DEFAULT_NEO4J_QUERY_CLIENT_OPTIONS,
} from '@internal/backstage-plugin-neo4j-ui-kit-react';

export const QueryClientProvider: CreateQueryClientProviderComponent =
  createQueryClientProvider(DEFAULT_NEO4J_QUERY_CLIENT_OPTIONS, {
    displayName: 'Neo4jNoticesQueryClientProvider',
  });
